import { useTranslation } from 'react-i18next';
import './LangflowContent.scss';
import SendIcon from '@mui/icons-material/Send';
import { FormInput } from 'ui/FormComponents';
import { FormProvider } from 'react-hook-form';
import { useLangflowChat } from '../../Hooks/useLangflowChat';
import { LangflowMessages } from '../LangflowMessages/LangflowMessages';
import StartChat from './StartChat/StartChat';

export const LangflowContent = () => {
  const { t } = useTranslation();

  const { messages, isLoading, messagesEndRef, formMethods, onSubmit } = useLangflowChat();

  return (
    <FormProvider {...formMethods}>
      <div className="langflow-chat-content">
        {(messages?.length ?? 0) === 0 && !isLoading && (
          <StartChat
            onClick={(message) => {
              formMethods.setValue('input_value', message);
              onSubmit();
            }}
          />
        )}
        {((messages?.length ?? 0) > 0 || isLoading) && (
          <LangflowMessages
            messages={messages ?? []}
            isLoading={isLoading}
            messagesEndRef={messagesEndRef}
          />
        )}

        <div className="langflow-chat-input-container">
          <FormInput
            name="input_value"
            placeHolderText={t('chat:placeholder')}
            disabled={isLoading}
            className="langflow-chat-input"
            iconPosition="end"
            icon={<SendIcon />}
            onClickIcon={() => onSubmit()}
            onKeyEnter={() => onSubmit()}
          />
        </div>
      </div>
    </FormProvider>
  );
};
